module.exports = function contentfulLoader({ src, width, quality }) {
  // Always return the Achieve logo without extra formatting options
  if (src === '/2026_Achieve_Logo_RGB.svg') return src

  // Allow all other svgs to specify a width
  if (src.endsWith('.svg')) return `${src}?w=${width}`

  const q = quality || 65

  // If the source is already webp/avif, skip webp conversion
  if (/\.(webp|avif)$/i.test(src)) {
    return `${src}?&w=${width}&q=${q}`
  }

  // By default, return non-svgs formatted as webp
  return `${src}?&w=${width}&fm=webp&q=${q}`
}
